import React from 'react';
import GeneralErrorPage from './GeneralErrorPage';
import { logError } from '../utils/errorLogger';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      hasError: false,
      error: null,
      errorInfo: null
    };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log error details to DevTools for immediate visibility...
    console.error('Error caught by ErrorBoundary:', error, errorInfo);

    this.setState({ error, errorInfo });

    // ...and persist to the Issues log so admins can review it later.
    try {
      logError({
        severity: 'critical',
        origin: 'frontend_exception',
        message: (error && error.message) || 'React render error',
        details: (error && error.name) ? `${error.name}: ${error.message}` : null,
        stack_trace: [
          error && error.stack ? error.stack : '',
          errorInfo && errorInfo.componentStack ? `\n\nComponent stack:${errorInfo.componentStack}` : '',
        ].join(''),
        context: { kind: 'ErrorBoundary' },
      });
    } catch (_e) { /* never raise */ }
  }

  resetError = () => {
    this.setState({ 
      hasError: false,
      error: null,
      errorInfo: null
    });
  };

  render() {
    if (this.state.hasError) {
      // Render custom error page
      return (
        <GeneralErrorPage 
          error={this.state.error} 
          resetError={this.resetError}
        />
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
